if (!customElements.get('bundle-components')) {
  customElements.define('bundle-components', class BundleComponents extends HTMLElement {
    constructor() {
      super();
      this.bundleComponentsInput = this.querySelector('#bundle-components');
      this.variantIdInput = this.querySelector('input[name="id"]');
      this.bundleComponentData = JSON.parse(document.getElementById('ProductJSON-bundlecomponent').textContent);
      if (this.variantIdInput) {
        this.variantIdInput.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    onVariantChange(event) {
      const variantId = event.target.value;
      // You might need to fetch new component data based on the variant
      // This depends on how your variant data is structured
      this.updateComponentsForVariant(variantId);
    }

    updateComponentsForVariant(variantId) {
      // Find the variant data in bundleComponentData
      const variantData = this.bundleComponentData.find(
        variant => variant.id.toString() === variantId.toString()
      );

      if (variantData && variantData.components) {
        // Update the bundle components input with the variant's components
        this.bundleComponentsInput.value = JSON.stringify(variantData.components);
      } else {
        console.warn(`No component data found for variant ID: ${variantId}`);
        this.bundleComponentsInput.value = '[]';
      }
    }

    getCurrentComponents() {
      try {
        return JSON.parse(this.bundleComponentsInput.value.replace(/'/g, '"'));
      } catch (e) {
        console.error('Error parsing bundle components:', e);
        return [];
      }
    }
  });
} 